import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
    Container,
    Row,
    Col,
    Button,
    Card,
    CardHeader,
    CardBody,
    Table,
    Input,
    Spinner,
    Pagination,
    PaginationItem,
    PaginationLink,
    Label,
    FormGroup,
    Modal,
    ModalHeader,
    ModalBody,
    Tooltip,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';

import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip as ChartTooltip,
    Legend,
    ResponsiveContainer,
    LabelList,
} from 'recharts';
import dayjs from 'dayjs';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';
import { apiURL1 } from '../../config';
import moment from 'moment';


const baseURL = apiURL1;


function MonthlyRecord() {
    const token = localStorage.getItem("token");
    const [activeTab, setActiveTab] = useState('cash');
    const [allTransactions, setAllTransactions] = useState([]);
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [total, setTotal] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [month, setMonth] = useState(dayjs().month() + 1);
    const [year, setYear] = useState(dayjs().year());
    const [filterDate, setFilterDate] = useState(''); // New state for date
    const [search, setSearch] = useState('');
    const [totalCashIncome, setTotalCashIncome] = useState(0);
    const [totalBankIncome, setTotalBankIncome] = useState(0);
    const [totalCashExpense, setTotalCashExpense] = useState(0);
    const [totalBankExpense, setTotalBankExpense] = useState(0);
    const [totalDonationAmount, setTotalDonationAmount] = useState(0);
    const [totalSalaryAmount, setTotalSalaryAmount] = useState(0);
    const [totalFees, setTotalFees] = useState(0);
    const [viewMode, setViewMode] = useState('table');
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [openViewModal, setOpenViewModal] = useState(false);
    const [openReportModal, setOpenReportModal] = useState(false);
    const [reportMonth, setReportMonth] = useState(dayjs().month() + 1);
    const [reportYear, setReportYear] = useState(dayjs().year());
    const [reportDate, setReportDate] = useState(''); // New state for report date
    const [reportData, setReportData] = useState(null);
    const chartRef = useRef(null);
    const [bankTransactions, setBankTransactions] = useState([]);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [tooltipId, setTooltipId] = useState(null);
    const [openingBalanceCash, setOpeningBalanceCash] = useState(0);
    const [openingBalanceBank, setOpeningBalanceBank] = useState(0);
    const [closingBankBalance, setClosingBankBalance] = useState(0);
    const [closingMonthlyBalance, setClosingMonthlyBalance] = useState(0);
    const [closingOverallBalance, setClosingOverallBalance] = useState(0);
    const [cashInHand, setCashInHand] = useState(0);
    const [cashInBank, setCashInBank] = useState(0);
    const [monthlyRecordsBank, setMonthlyRecordsBank] = useState([]);
    const [monthlyRecordsCash, setMonthlyRecordsCash] = useState([]);
    const [cashPage, setCashPage] = useState(1);
    const [bankPage, setBankPage] = useState(1);
    const [cashTotalPages, setCashTotalPages] = useState(1);
    const [bankTotalPages, setBankTotalPages] = useState(1);
    const [totalIncome, setTotalIncome] = useState(0);
    const [totalExpense, setTotalExpense] = useState(0);
    const [fullCashRecords, setFullCashRecords] = useState([]);
    const [fullBankRecords, setFullBankRecords] = useState([]);
    const [schoolInfo, setSchoolInfo] = useState({
        schoolName: "Ummu Dhardha Ladies Islamic college",
        schoolAddress: "Meera Nagar, Beach Road, Akkaraipattu. EP. 32400. Sri Lanka.",
        schoolPhoneNumber: "+94 67 205 3211",
        schoolEmail: "info@ummudhardha.lk",
        logo: "https://res.cloudinary.com/djg7v9dna/image/upload/v1739198257/Logo/kgamz0yjfr9uy8dsbnur.webp"
    });

    // Compute days in month for date dropdown
    const getDaysInMonth = (targetMonth = month, targetYear = year) => {
        const year = targetYear || moment().year();
        const month = targetMonth || moment().month() + 1;
        return moment(`${year}-${month}`, "YYYY-MM").daysInMonth();
    };

    useEffect(() => {
        fetchTransactions();
    }, [page, limit, month, year, filterDate, cashPage, bankPage, activeTab, search]);

    useEffect(() => {
        handleSearch();
    }, [search, allTransactions]);


    const handleExportCashCategoryPDF = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${baseURL}/superadmin/monthly-cash-category?month=${month}&year=${year}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            const {
                categorySummary,
                openingBalance,
                closingBalance,
                totalCashIncome,
                totalCashExpense,
                totalSalaryAmount,
                totalFees
            } = response.data;

            const pdf = new jsPDF('p', 'mm', 'a4');
            try {
                const imgData = await fetch(schoolInfo.logo)
                    .then(response => response.blob())
                    .then(blob => new Promise(resolve => {
                        const reader = new FileReader();
                        reader.onloadend = () => resolve(reader.result);
                        reader.readAsDataURL(blob);
                    }));
                pdf.addImage(imgData, 'WEBP', 10, 10, 30, 30);
            } catch (error) {
                console.error('Error loading logo:', error);
            }

            pdf.setFontSize(12);
            pdf.text(schoolInfo.schoolName, 50, 15);
            pdf.text(schoolInfo.schoolAddress, 50, 20);
            pdf.text(`Phone: ${schoolInfo.schoolPhoneNumber}`, 50, 25);
            pdf.text(`Email: ${schoolInfo.schoolEmail}`, 50, 30);

            pdf.setFontSize(16);
            pdf.text(`Cash Category Summary - ${dayjs().month(month - 1).format('MMMM')} ${year}`, 10, 46);

            const headers = [['Category', 'Income', 'Expense']];
            const rows = categorySummary.map(item => [
                item.category || '-',
                parseFloat(item.totalIncome).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                parseFloat(item.totalExpense).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            ]);

            rows.push(['', '', '']);
            rows.push(['Opening Balance', parseFloat(openingBalance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), '']);
            rows.push(['Total Income', parseFloat(totalCashIncome).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), '']);
            rows.push(['Total Expense', '', parseFloat(totalCashExpense).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")]);
            rows.push(['Closing Balance', parseFloat(closingBalance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), '']);
            rows.push(['Total Salary Amount', parseFloat(totalSalaryAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), '']);
            rows.push(['Total Fees', parseFloat(totalFees).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), '']);

            pdf.autoTable({
                startY: 50,
                head: headers,
                body: rows,
                theme: 'grid',
                styles: { fontSize: 8 },
                columnStyles: {
                    0: { cellWidth: 'auto' },
                    1: { cellWidth: 30 },
                    2: { cellWidth: 30 }
                }
            });

            const finalY = pdf.lastAutoTable.finalY || 50;
            pdf.setFontSize(10);
            pdf.text('Prepared By: ______________________', 10, finalY + 20);
            pdf.text('Checked By: ______________________', 80, finalY + 20);
            pdf.text('Treasurer: ______________________', 150, finalY + 20);

            pdf.save(`cash-category-summary-${month}-${year}.pdf`);
        } catch (error) {
            console.error('Error exporting cash category PDF:', error);
            toast.error('Error exporting cash category PDF');
        } finally {
            setLoading(false);
        }
    };

    const handleExportBankCategoryPDF = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${baseURL}/superadmin/monthly-bank-category?month=${month}&year=${year}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            const {
                categorySummary,
                openingBalance,
                closingBalance,
                totalBankIncome,
                totalBankExpense,
                totalDonationAmount
            } = response.data;

            const pdf = new jsPDF('p', 'mm', 'a4');
            try {
                const imgData = await fetch(schoolInfo.logo)
                    .then(response => response.blob())
                    .then(blob => new Promise(resolve => {
                        const reader = new FileReader();
                        reader.onloadend = () => resolve(reader.result);
                        reader.readAsDataURL(blob);
                    }));
                pdf.addImage(imgData, 'WEBP', 10, 10, 30, 30);
            } catch (error) {
                console.error('Error loading logo:', error);
            }

            pdf.setFontSize(12);
            pdf.text(schoolInfo.schoolName, 50, 15);
            pdf.text(schoolInfo.schoolAddress, 50, 20);
            pdf.text(`Phone: ${schoolInfo.schoolPhoneNumber}`, 50, 25);
            pdf.text(`Email: ${schoolInfo.schoolEmail}`, 50, 30);

            pdf.setFontSize(16);
            pdf.text(`Bank Category Summary - ${dayjs().month(month - 1).format('MMMM')} ${year}`, 10, 46);

            const headers = [['Category', 'Income', 'Expense']];
            const rows = categorySummary.map(item => [
                item.category || '-',
                parseFloat(item.totalIncome).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                parseFloat(item.totalExpense).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            ]);

            rows.push(['', '', '']);
            rows.push(['Opening Balance', parseFloat(openingBalance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), '']);
            rows.push(['Total Income', parseFloat(totalBankIncome).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), '']);
            rows.push(['Total Expense', '', parseFloat(totalBankExpense).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")]);
            rows.push(['Closing Balance', parseFloat(closingBalance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), '']);
            rows.push(['Total Donation Amount', parseFloat(totalDonationAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","), '']);

            pdf.autoTable({
                startY: 50,
                head: headers,
                body: rows,
                theme: 'grid',
                styles: { fontSize: 8 },
                columnStyles: {
                    0: { cellWidth: 'auto' },
                    1: { cellWidth: 30 },
                    2: { cellWidth: 30 }
                }
            });

            const finalY = pdf.lastAutoTable.finalY || 50;
            pdf.setFontSize(10);
            pdf.text('Prepared By: ______________________', 10, finalY + 20);
            pdf.text('Checked By: ______________________', 80, finalY + 20);
            pdf.text('Treasurer: ______________________', 150, finalY + 20);

            pdf.save(`bank-category-summary-${month}-${year}.pdf`);
        } catch (error) {
            console.error('Error exporting bank category PDF:', error);
            toast.error('Error exporting bank category PDF');
        } finally {
            setLoading(false);
        }
    };


    const fetchTransactions = async (fetchAll = false) => {
        try {
            setLoading(true);
            let isoDate = '';
            if (filterDate && month && year) {
                isoDate = `${year}-${String(month).padStart(2, '0')}-${String(filterDate).padStart(2, '0')}`;
            }

            const cashQuery = fetchAll
                ? `${baseURL}/superadmin/monthly-cash-summary?month=${month}&year=${year}&search=${search}${isoDate ? `&date=${isoDate}` : ''}`
                : `${baseURL}/superadmin/monthly-cash-summary?page=${cashPage}&limit=${limit}&month=${month}&year=${year}&search=${search}${isoDate ? `&date=${isoDate}` : ''}`;
            const bankQuery = fetchAll
                ? `${baseURL}/superadmin/monthly-bank-summary?month=${month}&year=${year}&search=${search}${isoDate ? `&date=${isoDate}` : ''}`
                : `${baseURL}/superadmin/monthly-bank-summary?page=${bankPage}&limit=${limit}&month=${month}&year=${year}&search=${search}${isoDate ? `&date=${isoDate}` : ''}`;

            const cashResponse = await axios.get(cashQuery, {
                headers: { 'Authorization': `Bearer ${token}` },
            });
            const { cashRecords, openingBalance, closingBalance, totalCashIncome: cashIncome, totalCashExpense: cashExpense, totalSalaryAmount: cashSalaryAmount, totalFees: cashFees, totalPages: cashPages, date } = cashResponse.data;

            const bankResponse = await axios.get(bankQuery, {
                headers: { 'Authorization': `Bearer ${token}` },
            });
            const { bankRecords, openingBalance: bankOpeningBalance, closingBalance: bankClosingBalance, totalBankIncome: bankIncome, totalBankExpense: bankExpense, totalDonationAmount, totalPages: bankPages } = bankResponse.data;

            if (fetchAll) {
                setFullCashRecords(cashRecords || []);
                setFullBankRecords(bankRecords || []);
            } else {
                setMonthlyRecordsCash(cashRecords || []);
                setMonthlyRecordsBank(bankRecords || []);
                setCashTotalPages(cashPages || 1);
                setBankTotalPages(bankPages || 1);
            }

            setOpeningBalanceCash(openingBalance || 0);
            setOpeningBalanceBank(bankOpeningBalance || 0);
            setTotalCashIncome(cashIncome || 0);
            setTotalBankIncome(bankIncome || 0);
            setTotalCashExpense(cashExpense || 0);
            setTotalBankExpense(bankExpense || 0);
            setTotalDonationAmount(totalDonationAmount || 0);
            setTotalSalaryAmount(cashSalaryAmount || 0);
            setTotalFees(cashFees || 0);
            setCashInHand(closingBalance || 0);
            setCashInBank(bankClosingBalance || 0);
            setClosingBankBalance(bankClosingBalance || 0);
            setClosingMonthlyBalance(closingBalance || 0);
            setClosingOverallBalance((closingBalance || 0) + (bankClosingBalance || 0));
            setTotalIncome(cashIncome + bankIncome);
            setTotalExpense(cashExpense + bankExpense);
            setAllTransactions([...cashRecords, ...bankRecords]);

            return {
                cashRecords: cashRecords || [],
                bankRecords: bankRecords || [],
                openingBalanceCash: openingBalance || 0,
                closingMonthlyBalance: closingBalance || 0,
                openingBalanceBank: bankOpeningBalance || 0,
                closingBankBalance: bankClosingBalance || 0,
                totalCashIncome: cashIncome || 0,
                totalBankIncome: bankIncome || 0,
                totalCashExpense: cashExpense || 0,
                totalBankExpense: bankExpense || 0,
                totalDonationAmount: totalDonationAmount || 0,
                totalSalaryAmount: cashSalaryAmount || 0,
                totalFees: cashFees || 0,
            };
        } catch (error) {
            console.error('Error fetching transactions:', error);
            toast.error('Error fetching transactions');
            throw error;
        } finally {
            setLoading(false);
        }
    };

    const handlePrintCash = async () => {
        const pdf = new jsPDF('p', 'mm', 'a4');
        try {
            const imgData = await fetch(schoolInfo.logo)
                .then(response => response.blob())
                .then(blob => new Promise(resolve => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.readAsDataURL(blob);
                }));
            pdf.addImage(imgData, 'WEBP', 10, 10, 30, 30);
        } catch (error) {
            console.error('Error loading logo:', error);
        }

        pdf.setFontSize(12);
        pdf.text(schoolInfo.schoolName, 50, 15);
        pdf.text(schoolInfo.schoolAddress, 50, 20);
        pdf.text(`Phone: ${schoolInfo.schoolPhoneNumber}`, 50, 25);
        pdf.text(`Email: ${schoolInfo.schoolEmail}`, 50, 30);

        pdf.setFontSize(16);
        pdf.text(`Cash Transactions - ${filterDate ? `${filterDate}-` : ''}${dayjs().month(month - 1).format('MMMM')} ${year}`, 10, 40);

        const headers = [['Voucher', 'Date', 'Category', 'Income', 'Expense', 'Description', 'Balance']];
        const rows = monthlyRecordsCash.map(transaction => [
            transaction.voucherNumber || '-',
            dayjs(transaction.date).format('DD-MM-YYYY'),
            transaction.categoryId?.name || '-',
            transaction.type === 'income' ? transaction.amount : '-',
            transaction.type === 'expense' ? transaction.amount : '-',
            transaction.description || '-',
            transaction.balance || '-'
        ]);

        rows.push(['', '', '', '', '', 'Opening Balance', openingBalanceCash]);
        rows.push(['', '', '', '', '', 'Closing Balance', closingMonthlyBalance]);

        pdf.autoTable({
            startY: 50,
            head: headers,
            body: rows,
            theme: 'grid',
            styles: { fontSize: 8 },
            columnStyles: {
                0: { cellWidth: 20 },
                1: { cellWidth: 25 },
                2: { cellWidth: 30 },
                3: { cellWidth: 20 },
                4: { cellWidth: 20 },
                5: { cellWidth: 40 },
                6: { cellWidth: 25 }
            }
        });

        pdf.save(`cash-transactions-${filterDate ? `${filterDate}-` : ''}${month}-${year}.pdf`);
    };

    const handlePrintBank = async () => {
        const pdf = new jsPDF('p', 'mm', 'a4');
        try {
            const imgData = await fetch(schoolInfo.logo)
                .then(response => response.blob())
                .then(blob => new Promise(resolve => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.readAsDataURL(blob);
                }));
            pdf.addImage(imgData, 'WEBP', 10, 10, 30, 30);
        } catch (error) {
            console.error('Error loading logo:', error);
        }

        pdf.setFontSize(12);
        pdf.text(schoolInfo.schoolName, 50, 15);
        pdf.text(schoolInfo.schoolAddress, 50, 20);
        pdf.text(`Phone: ${schoolInfo.schoolPhoneNumber}`, 50, 25);
        pdf.text(`Email: ${schoolInfo.schoolEmail}`, 50, 30);

        pdf.setFontSize(16);
        pdf.text(`Bank Transactions - ${filterDate ? `${filterDate}-` : ''}${dayjs().month(month - 1).format('MMMM')} ${year}`, 10, 40);

        const headers = [['Date', 'Category', 'Income', 'Expense', 'Description', 'Balance']];
        const rows = monthlyRecordsBank.map(transaction => [
            dayjs(transaction.date).format('DD-MM-YYYY'),
            transaction.categoryId?.name || '-',
            transaction.type === 'income' ? transaction.amount : '-',
            transaction.type === 'expense' ? transaction.amount : '-',
            transaction.description || '-',
            transaction.balance || '-'
        ]);

        rows.push(['', '', '', '', 'Opening Balance', openingBalanceBank]);
        rows.push(['', '', '', '', 'Closing Balance', closingBankBalance]);

        pdf.autoTable({
            startY: 50,
            head: headers,
            body: rows,
            theme: 'grid',
            styles: { fontSize: 8 },
            columnStyles: {
                0: { cellWidth: 25 },
                1: { cellWidth: 30 },
                2: { cellWidth: 20 },
                3: { cellWidth: 20 },
                4: { cellWidth: 40 },
                5: { cellWidth: 25 }
            }
        });

        pdf.save(`bank-transactions-${filterDate ? `${filterDate}-` : ''}${month}-${year}.pdf`);
    };

    const printTransactions = async (type) => {
        try {
            const data = await fetchTransactions(true);
            let transactionRecords = type === 'cash' ? data.cashRecords : data.bankRecords;
            let openingBalance = type === 'cash' ? data.openingBalanceCash : data.openingBalanceBank;
            let closingBalance = type === 'cash' ? data.closingMonthlyBalance : data.closingBankBalance;
            let title = type === 'cash'
                ? `Cash Transactions - ${filterDate ? `${filterDate}-` : ''}${dayjs().month(month - 1).format('MMMM')} ${year}`
                : `Bank Transactions - ${filterDate ? `${filterDate}-` : ''}${dayjs().month(month - 1).format('MMMM')} ${year}`;

            let firstDayOfMonth = filterDate
                ? dayjs(`${year}-${month}-${filterDate}`, 'YYYY-M-D').format('YYYY-MM-DD')
                : dayjs().year(year).month(month - 1).startOf('month').format('YYYY-MM-DD');

            let printWindow = window.open('', '', 'width=800,height=600');
            printWindow.document.write(`
          <html>
          <head>
            <title>${title}</title>
            <style>
              body { font-family: Arial, sans-serif; margin: 20px; text-align: center; }
              h2, h3 { margin: 5px 0; }
              table { width: 100%; border-collapse: collapse; margin-top: 20px; }
              th, td { border: 1px solid black; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; }
              .logo-container { text-align: center; margin-bottom: 10px; }
              .logo-container img { width: 80px; height: auto; }
            </style>
          </head>
          <body>
            <div class="logo-container">
              <img src="${schoolInfo.logo}" alt="School Logo">
            </div>
            <h2>${schoolInfo.schoolName}</h2>
            <h3>${schoolInfo.schoolAddress}</h3>
            <p>Phone: ${schoolInfo.schoolPhoneNumber} | Email: ${schoolInfo.schoolEmail}</p>
            <h2>${title}</h2>
            <table>
              <thead>
                <tr>
                  <th>Voucher</th>
                  <th>Date</th>
                  <th>Category</th>
                  <th>Income</th>
                  <th>Expense</th>
                  <th>Balance</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>-</td>
                  <td>${dayjs(firstDayOfMonth).format('DD-MM-YYYY')}</td>
                  <td>Opening Balance</td>
                  <td>${parseFloat(openingBalance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                  <td>-</td>
                  <td>${parseFloat(openingBalance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                  <td>-</td>
                </tr>
                ${transactionRecords.map(transaction => `
                  <tr>
                    <td>${transaction.voucherNumber || '-'}</td>
                    <td>${dayjs(transaction.date).format('DD-MM-YYYY')}</td>
                    <td>${transaction.categoryId?.name || '-'}</td>
                    <td>${transaction.type === 'income' ? parseFloat(transaction.amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '-'}</td>
                    <td>${transaction.type === 'expense' ? parseFloat(transaction.amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '-'}</td>
                    <td>${parseFloat(transaction.balance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") || '-'}</td>
                    <td>${transaction.description || '-'}</td>
                  </tr>
                `).join('')}
                <tr style="background-color: lightyellow;">
                  <td colspan="3"></td>
                  <td style="text-align: right;">
                    <strong>${parseFloat(type === 'cash' ? data.totalCashIncome : data.totalBankIncome).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</strong>
                  </td>
                  <td style="text-align: right;">
                    <strong>${parseFloat(type === 'cash' ? data.totalCashExpense : data.totalBankExpense).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</strong>
                  </td>
                  <td colspan="2"></td>
                </tr>
                <tr>
                  <td colspan="5" style="text-align: right;"><strong>${type === 'cash' ? 'Cash in Hand' : 'Cash in Bank'}</strong></td>
                  <td><strong>${parseFloat(closingBalance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</strong></td>
                  <td>-</td>
                </tr>
              </tbody>
            </table>
            <div style="display: flex; justify-content: space-between; width: 100%; margin-top: 20px;">
              <p style="margin: 4px 0; font-size: 16px;"><strong>Prepared By:</strong> <p style="margin: 4px 0; font-size: 16px;"> ______________________</p></p>
              <p style="margin: 4px 0; font-size: 16px;"><strong>Checked By:</strong><p style="margin: 4px 0; font-size: 16px;"> ______________________</p></p>
              <p style="margin: 4px 0; font-size: 16px;"><strong>Treasurer By:</strong> <p style="margin: 4px 0; font-size: 16px;"> ______________________</p></p>
            </div>
            <script>window.print();</script>
          </body>
          </html>
        `);
            printWindow.document.close();
        } catch (error) {
            console.error('Error printing transactions:', error);
            toast.error('Error printing transactions');
        }
    };

    const handleMonthChange = (newMonth) => {
        setMonth(newMonth);
        setPage(1);
        setCashPage(1);
        setBankPage(1);
        setFilterDate(''); // Reset date when month changes
    };

    const handleYearChange = (newYear) => {
        setYear(newYear);
        setPage(1);
        setCashPage(1);
        setBankPage(1);
        setFilterDate(''); // Reset date when year changes
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    const handleSearch = () => {
        if (!search) {
            setTransactions(allTransactions);
            return;
        }
        const filteredTransactions = allTransactions.filter((transaction) => {
            let searchableText = '';
            if (transaction.categoryId?.name) {
                searchableText = `${transaction.categoryId.name} ${transaction.description} ${transaction.amount}`.toLowerCase();
            }
            return searchableText.includes(search.toLowerCase());
        });
        setTransactions(filteredTransactions);
    };

    const handleViewModeChange = (mode) => {
        setViewMode(mode);
    };

    const handleOpenViewModal = (transaction) => {
        setSelectedTransaction(transaction);
        setOpenViewModal(true);
    };

    const handleCloseViewModal = () => {
        setOpenViewModal(false);
        setSelectedTransaction(null);
    };

    const renderPagination = (activePage, setActivePage, totalPages) => {
        const paginationItems = [];
        for (let i = 1; i <= totalPages; i++) {
            paginationItems.push(
                <PaginationItem key={i} active={i === activePage}>
                    <PaginationLink onClick={() => setActivePage(i)}>{i}</PaginationLink>
                </PaginationItem>
            );
        }
        return (
            <Pagination style={{ justifyContent: 'flex-end' }}>
                <PaginationItem disabled={activePage === 1}>
                    <PaginationLink previous onClick={() => setActivePage(activePage - 1)} />
                </PaginationItem>
                {paginationItems}
                <PaginationItem disabled={activePage === totalPages}>
                    <PaginationLink next onClick={() => setActivePage(activePage + 1)} />
                </PaginationItem>
            </Pagination>
        );
    };

    const barChartData = [
        { name: 'Summary', Income: totalIncome, Expense: totalExpense, Salary: totalSalaryAmount, Fees: totalFees },
    ];

    const handleOpenReportModal = () => {
        setOpenReportModal(true);
    };

    const handleCloseReportModal = () => {
        setOpenReportModal(false);
        setReportData(null);
        setReportDate('');
    };

    const handleGenerateReport = async () => {
        try {
            setLoading(true);
            let isoDate = '';
            if (reportDate && reportMonth && reportYear) {
                isoDate = `${reportYear}-${String(reportMonth).padStart(2, '0')}-${String(reportDate).padStart(2, '0')}`;
            }

            const cashResponse = await axios.get(
                `${baseURL}/superadmin/monthly-cash-summary?month=${reportMonth}&year=${reportYear}&search=${search}${isoDate ? `&date=${isoDate}` : ''}`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
            const { cashRecords, openingBalance, closingBalance, totalCashIncome: cashIncome, totalCashExpense: cashExpense, totalSalaryAmount: cashSalaryAmount, totalFees: cashFees } = cashResponse.data;

            const bankResponse = await axios.get(
                `${baseURL}/superadmin/monthly-bank-summary?month=${reportMonth}&year=${reportYear}&search=${search}${isoDate ? `&date=${isoDate}` : ''}`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
            const { bankRecords, openingBalance: bankOpeningBalance, closingBalance: bankClosingBalance, totalBankIncome: bankIncome, totalBankExpense: bankExpense, totalDonationAmount } = bankResponse.data;

            setReportData({
                cashRecords,
                bankRecords,
                totalCashIncome: cashIncome,
                totalCashExpense: cashExpense,
                totalBankIncome: bankIncome,
                totalBankExpense: bankExpense,
                totalDonationAmount,
                totalSalaryAmount: cashSalaryAmount,
                totalFees: cashFees,
                openingBalanceCash: openingBalance,
                closingBalanceCash: closingBalance,
                openingBankBalance: bankOpeningBalance,
                closingBankBalance: bankClosingBalance,
            });
        } catch (error) {
            console.error('Error fetching report data:', error);
            toast.error('Error fetching report data');
        } finally {
            setLoading(false);
        }
    };

    const handleDownloadPdf = async () => {
        if (!reportData) {
            toast.error('Please generate a report first.');
            return;
        }

        const pdf = new jsPDF('p', 'mm', [210, 297]);
        pdf.setFontSize(16);
        pdf.setFont('helvetica', 'bold');
        pdf.text(`Monthly Report - ${reportDate ? `${reportDate}-` : ''}${dayjs().month(reportMonth - 1).format('MMMM')} ${reportYear}`, 10, 15);

        pdf.setFontSize(12);
        pdf.setFont('helvetica', 'normal');
        let yPosition = 25;
        pdf.text(`Total Income: ${parseFloat(reportData.totalCashIncome + reportData.totalBankIncome).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, 10, yPosition);
        yPosition += 5;
        pdf.text(`Total Expense: ${parseFloat(reportData.totalCashExpense + reportData.totalBankExpense).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, 10, yPosition);
        yPosition += 5;
        pdf.text(`Total Donation Amount: ${parseFloat(reportData.totalDonationAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, 10, yPosition);
        yPosition += 5;
        pdf.text(`Total Salary Amount: ${parseFloat(reportData.totalSalaryAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, 10, yPosition);
        yPosition += 5;
        pdf.text(`Total Fees: ${parseFloat(reportData.totalFees).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, 10, yPosition);
        yPosition += 5;
        pdf.text(`Opening Bank Balance: ${parseFloat(reportData.openingBankBalance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, 10, yPosition);
        yPosition += 5;
        pdf.text(`Opening Monthly Balance: ${parseFloat(reportData.openingBalanceCash).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, 10, yPosition);
        yPosition += 5;
        pdf.text(`Closing Bank Balance: ${parseFloat(reportData.closingBankBalance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, 10, yPosition);
        yPosition += 5;
        pdf.text(`Closing Monthly Balance: ${parseFloat(reportData.closingBalanceCash).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`, 10, yPosition);
        yPosition += 10;

        const headers = ['Date', 'Category', 'Income', 'Expense', 'Description', 'Source', 'Balance'];
        const combinedTransactions = [...(reportData.cashRecords || []), ...(reportData.bankRecords || [])];
        const validTransactions = combinedTransactions.filter(transaction => transaction.categoryId?.name && transaction.amount);

        const tableData = validTransactions.map(transaction => {
            const income = transaction.type === 'income' ? transaction.amount.toString() : '0';
            const expense = transaction.type === 'expense' ? transaction.amount.toString() : '0';
            const source = transaction.transaction === 'withdrawal' || transaction.transaction === 'deposit' ? 'Bank' : 'Cash';
            return [
                dayjs(transaction.date).format('DD-MM-YYYY'),
                truncateText(transaction.categoryId?.name || '-', 20),
                parseFloat(income).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                parseFloat(expense).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                truncateText(transaction.description || '', 30),
                source,
                transaction.balance !== undefined ? parseFloat(transaction.balance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'N/A'
            ];
        });

        pdf.autoTable({
            head: [headers],
            body: tableData,
            startY: yPosition,
            styles: { fontSize: 10, cellPadding: 3 },
            columnStyles: {
                0: { cellWidth: 30 },
                1: { cellWidth: 30 },
                2: { cellWidth: 20 },
                3: { cellWidth: 20 },
                4: { cellWidth: 'auto' },
                5: { cellWidth: 20 },
                6: { cellWidth: 20 }
            }
        });

        if (chartRef.current) {
            const canvas = await html2canvas(chartRef.current);
            const imgData = canvas.toDataURL('image/png');
            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth() - 20;
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            const tableEndY = pdf.lastAutoTable.finalY;
            pdf.addImage(imgData, 'PNG', 10, tableEndY + 10, pdfWidth, pdfHeight);
        }

        pdf.save(`monthly-report-${reportDate ? `${reportDate}-` : ''}${dayjs().month(reportMonth - 1).format('MMMM')}-${reportYear}.pdf`);
    };

    const handleDownloadExcel = () => {
        if (!reportData) {
            toast.error('Please generate a report first.');
            return;
        }

        const XLSX = require('xlsx');
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet([], { skipHeader: true });

        XLSX.utils.sheet_add_aoa(ws, [
            [schoolInfo.schoolName],
            [schoolInfo.schoolAddress],
            [`Phone: ${schoolInfo.schoolPhoneNumber}`],
            [`Email: ${schoolInfo.schoolEmail}`],
            [],
            [`Monthly Report - ${reportDate ? `${reportDate}-` : ''}${dayjs().month(reportMonth - 1).format('MMMM')} ${reportYear}`],
        ], { origin: 'A1' });

        const summaryData = [
            [],
            ['Summary'],
            [`Total Income:`, parseFloat(reportData.totalCashIncome + reportData.totalBankIncome).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")],
            [`Total Expense:`, parseFloat(reportData.totalCashExpense + reportData.totalBankExpense).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")],
            [`Total Donation Amount:`, parseFloat(reportData.totalDonationAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")],
            [`Total Salary Amount:`, parseFloat(reportData.totalSalaryAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")],
            [`Total Fees:`, parseFloat(reportData.totalFees).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")],
            [`Opening Bank Balance:`, parseFloat(reportData.openingBankBalance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")],
            [`Opening Monthly Balance:`, parseFloat(reportData.openingBalanceCash).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")],
            [`Closing Bank Balance:`, parseFloat(reportData.closingBankBalance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")],
            [`Closing Monthly Balance:`, parseFloat(reportData.closingBalanceCash).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")],
            [],
        ];
        XLSX.utils.sheet_add_aoa(ws, summaryData, { origin: -1 });

        const headers = ['Date', 'Category', 'Income', 'Expense', 'Description', 'Source', 'Balance'];
        const combinedTransactions = [...(reportData.cashRecords || []), ...(reportData.cashRecords || [])];
        const validTransactions = combinedTransactions.filter(transaction => transaction.categoryId?.name && transaction.amount);

        const tableData = validTransactions.map(transaction => ({
            Date: dayjs(transaction.date).format('DD-MM-YYYY'),
            Category: truncateText(transaction.categoryId?.name || '-', 20),
            Income: transaction.type === 'income' ? parseFloat(transaction.amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00',
            Expense: transaction.type === 'expense' ? parseFloat(transaction.amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00',
            Description: truncateText(transaction.description || '', 30),
            Source: transaction.transaction === 'withdrawal' || transaction.transaction === 'deposit' ? 'Bank' : 'Cash',
            Balance: transaction.balance !== undefined ? parseFloat(transaction.balance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'N/A',
        }));

        XLSX.utils.sheet_add_aoa(ws, [headers], { origin: -1 });
        XLSX.utils.sheet_add_json(ws, tableData, { origin: -1, skipHeader: true });

        ws['!cols'] = [
            { wch: 15 },
            { wch: 20 },
            { wch: 15 },
            { wch: 15 },
            { wch: 30 },
            { wch: 10 },
            { wch: 15 },
        ];

        XLSX.utils.book_append_sheet(wb, ws, 'Monthly Report');
        XLSX.writeFile(wb, `monthly-report-${reportDate ? `${reportDate}-` : ''}${dayjs().month(reportMonth - 1).format('MMMM')}-${reportYear}.xlsx`);
    };

    const toggleTooltip = (id) => {
        setTooltipOpen(!tooltipOpen);
        setTooltipId(id);
    };

    const getRowColor = (transaction) => {
        if (transaction.type === 'income') return '#e6ffe6';
        if (transaction.type === 'expense') return '#ffe6e6';
        return 'white';
    };

    const truncateText = (text, maxLength) => {
        if (!text) return '';
        if (text.length > maxLength) return text.substring(0, maxLength) + '...';
        return text;
    };

    const toggleTab = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    return (
        <Container>
            <Row className="mb-3">
                <Col xs={12} md={3} style={{ marginBottom: '0.5rem' }}>
                    <FormGroup>
                        <Label>Month</Label>
                        <Input
                            type="select"
                            value={month}
                            onChange={(e) => handleMonthChange(parseInt(e.target.value))}
                        >
                            <option value="">Select Month</option>
                            {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                                <option key={m} value={m}>
                                    {dayjs().month(m - 1).format('MMMM')}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                </Col>
                <Col xs={12} md={3} style={{ marginBottom: '0.5rem' }}>
                    <FormGroup>
                        <Label>Year</Label>
                        <Input
                            type="select"
                            value={year}
                            onChange={(e) => handleYearChange(parseInt(e.target.value))}
                        >
                            <option value="">Select Year</option>
                            {Array.from({ length: 10 }, (_, i) => dayjs().year() - 5 + i).map((y) => (
                                <option key={y} value={y}>{y}</option>
                            ))}
                        </Input>
                    </FormGroup>
                </Col>
                <Col xs={12} md={3} style={{ marginBottom: '0.5rem' }}>
                    <FormGroup>
                        <Label>Date</Label>
                        <Input
                            type="select"
                            value={filterDate}
                            onChange={(e) => setFilterDate(e.target.value)}
                            disabled={!month || !year}
                        >
                            <option value="">Select Date</option>
                            {[...Array(getDaysInMonth())].map((_, i) => {
                                const day = i + 1;
                                return (
                                    <option key={day} value={day}>{day}</option>
                                );
                            })}
                        </Input>
                    </FormGroup>
                </Col>
                <Col xs={12} md={3} style={{ marginBottom: '0.5rem' }}>
                    <FormGroup>
                        <Label>Search</Label>
                        <Input
                            type="text"
                            placeholder="Search..."
                            value={search}
                            onChange={handleSearchChange}
                        />
                    </FormGroup>
                </Col>
                <Col xs={12} md={2} className="d-flex align-items-end justify-content-end" style={{ marginBottom: '0.5rem' }}>
                    <Button color="primary" onClick={handleOpenReportModal} style={{ width: '100%', fontSize: '0.8rem' }}>
                        Report
                    </Button>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col xs={12}>
                    <div className="d-flex justify-content-end">
                        <Button
                            color={viewMode === 'table' ? 'primary' : 'secondary'}
                            onClick={() => handleViewModeChange('table')}
                            className="me-2"
                            style={{ marginBottom: '0.5rem', width: '45%', fontSize: '0.8rem' }}
                        >
                            View Table
                        </Button>
                        <Button
                            color={viewMode === 'graph' ? 'primary' : 'secondary'}
                            onClick={() => handleViewModeChange('graph')}
                            style={{ marginBottom: '0.5rem', width: '45%', fontSize: '0.8rem' }}
                        >
                            View Graph
                        </Button>
                    </div>
                </Col>
            </Row>

            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                    <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                </div>
            ) : (
                <>
                    {viewMode === 'table' && (
                        <>
                            <Row>
                                <Col xs={12} md={6}>
                                    <p style={{ fontSize: '0.9rem' }}><strong>Total Income (Bank+ Cash):</strong> {parseFloat(totalIncome).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                    <p style={{ fontSize: '0.9rem' }}><strong>Total Expense (Bank+ Cash):</strong> {parseFloat(totalExpense).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                    <p style={{ fontSize: '0.9rem' }}><strong>Total Donation Amount (Bank+ Cash):</strong> {parseFloat(totalDonationAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                    <p style={{ fontSize: '0.9rem' }}><strong>Total Salary Amount (Bank+ Cash):</strong> {parseFloat(totalSalaryAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                    <p style={{ fontSize: '0.9rem' }}><strong>Total Fees (Bank+ Cash):</strong> {parseFloat(totalFees).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </Col>
                                <Col xs={12} md={6}></Col>
                            </Row>
                            <Nav tabs style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center' }}>
                                <NavItem>
                                    <NavLink
                                        active={activeTab === 'cash'}
                                        onClick={() => toggleTab('cash')}
                                        style={{
                                            backgroundColor: activeTab === 'cash' ? '#007bff' : '#6c757d',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '0.25rem',
                                            padding: '0.5rem 1rem',
                                            cursor: 'pointer',
                                            fontSize: '0.8rem',
                                        }}
                                    >
                                        Cash Transactions
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        active={activeTab === 'bank'}
                                        onClick={() => toggleTab('bank')}
                                        style={{
                                            backgroundColor: activeTab === 'bank' ? '#007bff' : '#6c757d',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '0.25rem',
                                            padding: '0.5rem 1rem',
                                            cursor: 'pointer',
                                            fontSize: '0.8rem',
                                        }}
                                    >
                                        Bank Transactions
                                    </NavLink>
                                </NavItem>
                                {activeTab === 'cash' && (
                                    <Button
                                        color="primary"
                                        onClick={handleExportCashCategoryPDF}
                                        style={{ marginLeft: 'auto', marginRight: '1rem' }}
                                    >
                                        Export Cash PDF
                                    </Button>
                                )}
                                {activeTab === 'bank' && (
                                    <Button
                                        color="primary"
                                        onClick={handleExportBankCategoryPDF}
                                        style={{ marginLeft: 'auto', marginRight: '1rem' }}
                                    >
                                        Export Bank PDF
                                    </Button>
                                )}
                                <Button
                                    color="primary"
                                    onClick={() => printTransactions(activeTab === 'cash' ? 'cash' : 'bank')}
                                    style={{ marginLeft: 'auto' }}
                                >
                                    Print
                                </Button>
                            </Nav>

                            {activeTab === 'cash' && (
                                <Row>
                                    <Col xs={12}>
                                        <Card>
                                            <CardHeader>
                                                <h3>Cash Transactions</h3>
                                            </CardHeader>
                                            <CardBody>
                                                <p style={{ fontSize: '0.9rem' }}><strong>Opening Balance:</strong> {parseFloat(openingBalanceCash).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                                <p style={{ fontSize: '0.9rem' }}><strong>Closing Balance:</strong> {parseFloat(closingMonthlyBalance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                                <Table responsive style={{ fontSize: '0.8rem' }}>
                                                    <thead>
                                                        <tr>
                                                            <th>Voucher Number</th>
                                                            <th>Date</th>
                                                            <th>Category</th>
                                                            <th>Description</th>
                                                            <th>Income</th>
                                                            <th>Expense</th>
                                                            <th>Balance</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {monthlyRecordsCash.map((transaction) => (
                                                            <tr key={transaction._id} style={{ backgroundColor: getRowColor(transaction) }}>
                                                                <td>{truncateText(transaction.voucherNumber || '-', 20)}</td>
                                                                <td>{dayjs(transaction.date).format('DD-MM-YYYY')}</td>
                                                                <td>{truncateText(transaction.categoryId?.name || '-', 20)}</td>
                                                                <td>{truncateText(transaction.description, 30)}</td>
                                                                <td>{transaction.type === 'income' ? parseFloat(transaction.amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.0'}</td>
                                                                <td>{transaction.type === 'expense' ? parseFloat(transaction.amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.0'}</td>
                                                                <td>{parseFloat(transaction.balance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                                            </tr>
                                                        ))}
                                                        <tr style={{ backgroundColor: 'lightyellow' }}>
                                                            <td colSpan="5" style={{ textAlign: 'right' }}>
                                                                <strong>{parseFloat(totalCashIncome).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</strong>
                                                            </td>
                                                            <td style={{ textAlign: 'left' }}>
                                                                <strong>{parseFloat(totalCashExpense).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</strong>
                                                            </td>
                                                        </tr>
                                                        <tr style={{ backgroundColor: 'lightyellow' }}>
                                                            <td colSpan="6"><strong>Cash in Hand:</strong></td>
                                                            <td><strong>{parseFloat(cashInHand).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</strong></td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                                <Row>
                                                    <Col style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        {renderPagination(cashPage, setCashPage, cashTotalPages)}
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            )}
                            {activeTab === 'bank' && (
                                <Row>
                                    <Col xs={12}>
                                        <Card>
                                            <CardHeader>
                                                <h3>Bank Transactions</h3>
                                            </CardHeader>
                                            <CardBody>
                                                <p style={{ fontSize: '0.9rem' }}><strong>Opening Balance:</strong> {parseFloat(openingBalanceBank).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                                <p style={{ fontSize: '0.9rem' }}><strong>Closing Balance:</strong> {parseFloat(closingBankBalance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                                <Table responsive style={{ fontSize: '0.8rem' }}>
                                                    <thead>
                                                        <tr>
                                                            <th>Voucher Number</th>
                                                            <th>Date</th>
                                                            <th>Category</th>
                                                            <th>Description</th>
                                                            <th>Income</th>
                                                            <th>Expense</th>
                                                            <th>Balance</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {monthlyRecordsBank.map((transaction) => (
                                                            <tr key={transaction._id} style={{ backgroundColor: getRowColor(transaction) }}>
                                                                <td>{truncateText(transaction.voucherNumber || '-', 20)}</td>
                                                                <td>{dayjs(transaction.date).format('DD-MM-YYYY')}</td>
                                                                <td>{truncateText(transaction.categoryId?.name || '-', 20)}</td>
                                                                <td>{truncateText(transaction.description, 30)}</td>
                                                                <td>{transaction.type === 'income' ? parseFloat(transaction.amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.0'}</td>
                                                                <td>{transaction.type === 'expense' ? parseFloat(transaction.amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.0'}</td>
                                                                <td>{parseFloat(transaction.balance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                                            </tr>
                                                        ))}
                                                        <tr style={{ backgroundColor: 'lightyellow' }}>
                                                            <td colSpan="5" style={{ textAlign: 'right' }}>
                                                                <strong>{parseFloat(totalBankIncome).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</strong>
                                                            </td>
                                                            <td style={{ textAlign: 'left' }}>
                                                                <strong>{parseFloat(totalBankExpense).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</strong>
                                                            </td>
                                                        </tr>
                                                        <tr style={{ backgroundColor: 'lightyellow' }}>
                                                            <td colSpan="4"><strong>Cash in Bank:</strong></td>
                                                            <td><strong>{parseFloat(cashInBank).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</strong></td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                                <Row>
                                                    <Col style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        {renderPagination(bankPage, setBankPage, bankTotalPages)}
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            )}
                        </>
                    )}

                    {viewMode === 'graph' && (
                        <Row>
                            <Col xs={12}>
                                <Card>
                                    <CardHeader>
                                        <h3>Monthly Summary</h3>
                                    </CardHeader>
                                    <CardBody>
                                        <ResponsiveContainer width="100%" height={300}>
                                            <BarChart data={barChartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="name" />
                                                <YAxis />
                                                <Legend />
                                                <Bar dataKey="Income" fill="#0088FE">
                                                    <LabelList dataKey="Income" position="top" />
                                                </Bar>
                                                <Bar dataKey="Expense" fill="#FF4949">
                                                    <LabelList dataKey="Expense" position="top" />
                                                </Bar>
                                                <Bar dataKey="Salary" fill="#00C49F">
                                                    <LabelList dataKey="Salary" position="top" />
                                                </Bar>
                                                <Bar dataKey="Fees" fill="#FFBB28">
                                                    <LabelList dataKey="Fees" position="top" />
                                                </Bar>
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    )}
                </>
            )}

            <Modal isOpen={openViewModal} toggle={handleCloseViewModal}>
                <ModalHeader toggle={handleCloseViewModal}>Transaction Details</ModalHeader>
                <ModalBody style={{ overflowWrap: 'break-word' }}>
                    {selectedTransaction && (
                        <div>
                            <p><b>Date:</b> {dayjs(selectedTransaction.date).format('DD-MM-YYYY')}</p>
                            <p><b>Category:</b> {selectedTransaction.categoryId?.name || '-'}</p>
                            <p><b>Type:</b> {selectedTransaction.type}</p>
                            <p><b>Amount:</b> {selectedTransaction.amount}</p>
                            <p><b>Description:</b> {selectedTransaction.description || '-'}</p>
                            <p><b>Source:</b> {selectedTransaction.transaction === 'withdrawal' || selectedTransaction.transaction === 'deposit' ? 'Bank' : 'Cash'}</p>
                        </div>
                    )}
                </ModalBody>
            </Modal>
            <Modal isOpen={openReportModal} toggle={handleCloseReportModal} size="lg">
                <ModalHeader toggle={handleCloseReportModal}>Generate Report</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col xs={12} md={4} style={{ marginBottom: '0.5rem' }}>
                            <FormGroup>
                                <Label>Month</Label>
                                <Input
                                    type="select"
                                    value={reportMonth}
                                    onChange={(e) => setReportMonth(parseInt(e.target.value))}
                                >
                                    <option value="">Select Month</option>
                                    {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                                        <option key={m} value={m}>
                                            {dayjs().month(m - 1).format('MMMM')}
                                        </option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={4} style={{ marginBottom: '0.5rem' }}>
                            <FormGroup>
                                <Label>Year</Label>
                                <Input
                                    type="select"
                                    value={reportYear}
                                    onChange={(e) => setReportYear(parseInt(e.target.value))}
                                >
                                    <option value="">Select Year</option>
                                    {Array.from({ length: 10 }, (_, i) => dayjs().year() - 5 + i).map((y) => (
                                        <option key={y} value={y}>{y}</option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={4} style={{ marginBottom: '0.5rem' }}>
                            <FormGroup>
                                <Label>Date</Label>
                                <Input
                                    type="select"
                                    value={reportDate}
                                    onChange={(e) => setReportDate(e.target.value)}
                                    disabled={!reportMonth || !reportYear}
                                >
                                    <option value="">Select Date</option>
                                    {[...Array(getDaysInMonth(reportMonth, reportYear))].map((_, i) => {
                                        const day = i + 1;
                                        return (
                                            <option key={day} value={day}>{day}</option>
                                        );
                                    })}
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Button color="primary" onClick={handleGenerateReport} disabled={loading} style={{ fontSize: '0.8rem' }}>
                        {loading ? <Spinner size="sm" /> : 'Preview'}
                    </Button>
                    {reportData && (
                        <div className="mt-3">
                            <Row>
                                <Col xs={12} md={6}>
                                    <p style={{ fontSize: '0.9rem' }}><strong>Total Income:</strong> {parseFloat(reportData.totalCashIncome + reportData.totalBankIncome).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                    <p style={{ fontSize: '0.9rem' }}><strong>Total Expense:</strong> {parseFloat(reportData.totalCashExpense + reportData.totalBankExpense).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                    <p style={{ fontSize: '0.9rem' }}><strong>Total Donation Amount:</strong> {parseFloat(reportData.totalDonationAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                    <p style={{ fontSize: '0.9rem' }}><strong>Total Salary Amount:</strong> {parseFloat(reportData.totalSalaryAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                    <p style={{ fontSize: '0.9rem' }}><strong>Total Fees:</strong> {parseFloat(reportData.totalFees).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </Col>
                                <Col xs={12} md={6}>
                                    <p style={{ fontSize: '0.9rem' }}><strong>Opening Bank Balance:</strong> {parseFloat(reportData.openingBankBalance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                    <p style={{ fontSize: '0.9rem' }}><strong>Opening Monthly Balance:</strong> {parseFloat(reportData.openingBalanceCash).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                    <p style={{ fontSize: '0.9rem' }}><strong>Cash In Hand:</strong> {parseFloat(reportData.closingBalanceCash).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                    <p style={{ fontSize: '0.9rem' }}><strong>Cash In Bank:</strong> {parseFloat(reportData.closingBankBalance).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </Col>
                            </Row>
                            <div ref={chartRef}>
                                <ResponsiveContainer width="100%" height={300}>
                                    <BarChart data={[
                                        { name: 'Summary', Income: reportData.totalCashIncome + reportData.totalBankIncome, Expense: reportData.totalCashExpense + reportData.totalBankExpense, Salary: reportData.totalSalaryAmount, Fees: reportData.totalFees },
                                    ]} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="name" />
                                        <YAxis />
                                        <Legend />
                                        <Bar dataKey="Income" fill="#0088FE">
                                            <LabelList dataKey="Income" position="top" />
                                        </Bar>
                                        <Bar dataKey="Expense" fill="#FF4949">
                                            <LabelList dataKey="Expense" position="top" />
                                        </Bar>
                                        <Bar dataKey="Salary" fill="#00C49F">
                                            <LabelList dataKey="Salary" position="top" />
                                        </Bar>
                                        <Bar dataKey="Fees" fill="#FFBB28">
                                            <LabelList dataKey="Fees" position="top" />
                                        </Bar>
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button color="primary" onClick={handleDownloadPdf} className="mt-2" style={{ fontSize: '0.8rem' }}>
                                    Download as PDF
                                </Button>
                                <Button color="primary" onClick={handleDownloadExcel} className="mt-2" style={{ fontSize: '0.8rem' }}>
                                    Download as Excel
                                </Button>
                            </div>
                        </div>
                    )}
                </ModalBody>
            </Modal>
        </Container>
    );
}


export default MonthlyRecord;
